/** @jsx jsx */
import React, { type ReactNode } from 'react';
import { css, jsx } from '@compiled/react';
import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';
import type { IntlShape } from '@atlassian/jira-intl';
import type { ComponentUser } from '../../../../common/model/types.tsx';
import messages from './messages.tsx';

type Props = {
	user?: ComponentUser;
	intl: IntlShape;
};

export default function LeadView(props: Props) {
	const { formatMessage } = props.intl;

	if (!props.user) {
		return null;
	}

	const { avatarUrl, displayName, profileUrl, active } = props.user;

	return (
		<a
			css={LinkStyles}
			href={profileUrl}
			data-testid="project-directories.components.table.cell.lead.link"
		>
			<div css={WrapperStyles}>
				<div css={AvatarContainerStyles}>
					<Avatar src={avatarUrl} size="small" key="avatar" />
				</div>
				{active === true
					? displayName
					: // @ts-expect-error - TS2769: No overload matches this call.
						formatMessage(messages.deactivated, {
							userName: displayName,
							status: (text: string[]): ReactNode => <span css={UserStatusStyles}>{text[0]}</span>,
						})}
			</div>
		</a>
	);
}

const WrapperStyles = css({
	display: 'flex',
	alignItems: 'center',
});

const LinkStyles = css({
	display: 'inline-block',
});

const AvatarContainerStyles = css({
	paddingRight: token('space.100'),
	display: 'flex',
});

const UserStatusStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
	color: token('color.text.subtlest'),
});
